/**
 * Common
 *
 * Scripts for all pages.
 *
 * @since 1.0.0
 */

// import $ from 'jquery';
import copy from "copy-to-clipboard";
import initFavListButtons from "../artworksearch/initFavListButtons";

export default {
  init() {
    // Hamburger menu icon
    const hamburger = document.querySelector(".hamburger");
    const overlay = document.querySelector(".overlay");
    const body = document.querySelector("body");
    // Activate menu
    hamburger.addEventListener("click", function() {
      hamburger.classList.toggle("is-active");
      overlay.classList.toggle("is-active");
      body.classList.toggle("noscroll");
    });

    // Handle favourites list dropdown links
    jQuery(".fav-header__select").change(function() {
      window.location.href = jQuery(jQuery("option:selected", this)[0]).data(
        "permalink"
      );
    });

    // Handle favourites list link copy
    jQuery(".fav-header__button--link").on("click", function() {
      const width = jQuery(this).width();
      copy(window.location.href);
      jQuery(this).text("Kopioitu");
      jQuery(this).addClass("copied");
      jQuery(this).width(width);
      const that = this;
      setTimeout(function() {
        jQuery(that).removeClass("copied");
      }, 100);
    });

    // Handle favourites list delete
    jQuery(".fav-header__button--remove").on("click", () => {
      if (!confirm("Haluatko varmasti poistaa suosikkilistan?")) {
        return;
      }
      const { removeId, removeLink } = document.querySelector(
        ".fav-header__button--remove"
      ).dataset;
      fetch(`/wp-json/wp/v2/suosikit/${removeId}`, {
        method: "DELETE",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-WP-Nonce": gage.nonce
        },
        redirect: "follow",
        referrer: "no-referrer"
      }).then(() => (window.location.href = removeLink));
    });

    // Init artwork buttons for fav list
    if (
      document.querySelector(".favourites-list") ||
      document.querySelector(".artwork__header")
    ) {
      initFavListButtons();
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  }
};
